import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import { FC, useMemo } from "react";

import { ColorRing } from "react-loader-spinner";

interface ISpinner {
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
    color?: "primary" | "white";
    isTextLoading?: boolean;
    className?: string;
}

const Spinner: FC<ISpinner> = ({
    size = 'md',
    color = "primary",
    isTextLoading = true,
    className
}) => {

    const sizeSpinner = useMemo(() => {
        const sizeMap: Record<
            string,
            {
                width: number;
                height: number;
            }
        > = {
            xs: { width: 24, height: 24 },
            sm: { width: 30, height: 30 },
            md: { width: 48, height: 48 },
            lg: { width: 64, height: 64 },
            xl: { width: 80, height: 80 },
            default: { width: 40, height: 40 },
        };

        return sizeMap[size] || sizeMap.default;
    }, [size]);

    const COLOR_SPINNER: {[key: string]: string} = {
        primary: "#158284",
        white: "#fff"
    }

    return (
        <div className={`inline-block text-center ${className}`}>
            {/* <ColorRing
                visible={true}
                height={sizeSpinner.height}
                width={sizeSpinner.width}
                ariaLabel="color-ring-loading"
                colors={[color, color, color, color, color]}
            /> */}
            <Spin indicator={<LoadingOutlined spin height={sizeSpinner.height}
                width={sizeSpinner.width} color={COLOR_SPINNER[color]} style={{color:COLOR_SPINNER[color]}} />} size={["xs","sm"]?.includes(size) ? "small" : size === "md" ? "default" : "large"}  />
            {isTextLoading && <p className="text-neutral-300 text-sm">Loading...</p>}
        </div>
    );
};

export default Spinner;